"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _ListItemAvatar = _interopRequireDefault(require("../ListItemAvatar"));

var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon"));

var _ListItemSecondaryAction = _interopRequireDefault(require("../ListItemSecondaryAction"));

var _ListItemText = _interopRequireDefault(require("../ListItemText"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _Button = _interopRequireDefault(require("../Button"));

var _excluded = ["children"],
    _excluded2 = ["id", "isSideNav", "itemSideNav", "dataId", "className", "itemAvatar", "ListItemAvatarProps", "itemIcon", "ListItemIconProps", "iconLocation", "itemSecondaryAction", "ListItemSecondaryActionProps", "itemText", "ListItemTextProps", "button", "AvatarProps", "hide", "openInNewWindow", "target"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    sideNavItem: {
      textTransform: "none",
      padding: theme.spacing(1.5, 4),
      letterSpacing: 0,
      wordWrap: "break-word",
      "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: ".33rem",
        height: "75%",
        display: "block",
        background: "transparent",
        transform: "translateY(-16%)",
        transition: theme.transitions.create("background")
      },
      "&:hover": {
        background: theme.palette.action.hover
      },
      "&$selected": {
        "&:before": {
          background: theme.palette.primary.main
        }
      }
    },
    selected: {},
    secondaryAction: {
      position: "static",
      top: "auto",
      right: "auto",
      transform: "none",
      display: "flex"
    }
  };
});

var renderButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    innerRef: ref,
    variant: "text"
  }, otherProps), children));
});

renderButton.displayName = "ListItemButton";

var ListItem = function ListItem(props) {
  var _otherProps$classes;

  var id = props.id,
      isSideNav = props.isSideNav,
      itemSideNav = props.itemSideNav,
      dataId = props.dataId,
      className = props.className,
      itemAvatar = props.itemAvatar,
      ListItemAvatarProps = props.ListItemAvatarProps,
      itemIcon = props.itemIcon,
      ListItemIconProps = props.ListItemIconProps,
      iconLocation = props.iconLocation,
      itemSecondaryAction = props.itemSecondaryAction,
      ListItemSecondaryActionProps = props.ListItemSecondaryActionProps,
      itemText = props.itemText,
      ListItemTextProps = props.ListItemTextProps,
      button = props.button,
      AvatarProps = props.AvatarProps,
      hide = props.hide,
      openInNewWindow = props.openInNewWindow,
      target = props.target,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var classes = useStyles();
  var renderedAvatar = itemAvatar;
  if (ListItemAvatarProps !== null && ListItemAvatarProps !== void 0 && ListItemAvatarProps.children) renderedAvatar = ListItemAvatarProps.children;

  var iconSection = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderedAvatar && /*#__PURE__*/_react.default.createElement(_ListItemAvatar.default, (0, _extends2.default)({
    id: ListItemAvatarProps !== null && ListItemAvatarProps !== void 0 && ListItemAvatarProps.id || id ? "listItemAvatar-".concat(id) : undefined
  }, ListItemAvatarProps), /*#__PURE__*/_react.default.createElement(_Avatar.default, (0, _extends2.default)({
    id: AvatarProps !== null && AvatarProps !== void 0 && AvatarProps.id || id ? "avatar-".concat(id) : undefined,
    size: "medium"
  }, AvatarProps), (AvatarProps === null || AvatarProps === void 0 ? void 0 : AvatarProps.children) || renderedAvatar)), ((ListItemIconProps === null || ListItemIconProps === void 0 ? void 0 : ListItemIconProps.children) || itemIcon) && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, (0, _extends2.default)({
    id: ListItemIconProps !== null && ListItemIconProps !== void 0 && ListItemIconProps.id || id ? "listItemIcon-".concat(id) : undefined
  }, ListItemIconProps), (ListItemIconProps === null || ListItemIconProps === void 0 ? void 0 : ListItemIconProps.children) || itemIcon));

  var textSection = /*#__PURE__*/_react.default.createElement(_ListItemText.default, (0, _extends2.default)({
    id: itemText !== null && itemText !== void 0 && itemText.id || ListItemTextProps !== null && ListItemTextProps !== void 0 && ListItemTextProps.id || id ? "listItemText-".concat(id) : undefined
  }, itemText, ListItemTextProps));

  var actionSection = /*#__PURE__*/_react.default.createElement(_ListItemSecondaryAction.default, (0, _extends2.default)({
    id: ListItemSecondaryActionProps !== null && ListItemSecondaryActionProps !== void 0 && ListItemSecondaryActionProps.id || id ? "listItemSecondaryAction-".concat(id) : undefined
  }, ListItemSecondaryActionProps, {
    className: (0, _classnames.default)(classes.secondaryAction, ListItemSecondaryActionProps === null || ListItemSecondaryActionProps === void 0 ? void 0 : ListItemSecondaryActionProps.className)
  }), (ListItemSecondaryActionProps === null || ListItemSecondaryActionProps === void 0 ? void 0 : ListItemSecondaryActionProps.children) || itemSecondaryAction);

  return hide ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    "data-id": dataId,
    id: id
  }, otherProps, {
    classes: _objectSpread(_objectSpread({}, otherProps.classes), {}, {
      selected: (0, _classnames.default)((_otherProps$classes = otherProps.classes) === null || _otherProps$classes === void 0 ? void 0 : _otherProps$classes.selected, classes.selected)
    }),
    className: (0, _classnames.default)("prmbl-listItem", className, (0, _defineProperty2.default)({}, classes.sideNavItem, isSideNav || itemSideNav)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Seems the MUI interface is wrong here
    ,
    button: button,
    target: openInNewWindow ? "_blank" : target,
    component: otherProps.component ? otherProps.component : button ? renderButton : undefined
  }), iconLocation === "right" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, textSection, iconSection, actionSection) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, iconSection, textSection, actionSection));
};

exports.ListItem = ListItem;
ListItem.defaultProps = {
  iconLocation: "left"
};
var _default = ListItem;
exports.default = _default;